<div class="container">
  <div class="container-toggle">
    <mat-slide-toggle
      class="toggle"
      (change)="changeToggle($event)"
      [(ngModel)]="isChecked"
      >{{ labelToggle }}</mat-slide-toggle
    >
  </div>

  <data-table
    [titleExcelFile]="'bodegas_inventario'"
    [columns]="columnsW"
    [url]="urlTableW"
    [configuration]="configurationW"
    [reloadTable]="reloadTableW"
    [params]="paramsWarehouse"
    [headerFilters]="headerFilters"
    [headerFileXlsm]="headerFileXlsm"
    (add)="addW($event)"
    (edit)="editW($event)"
    (active)="inactivateOrActiveWarehouses($event, !isChecked)"
    (internalData)="dataFromTable($event)"
  >
  </data-table>
</div>
